import _ from 'lodash';

import Entity from './Entity';


// @CMN Improve...
const monthEnum = {
  'Jan': 0,
  'Feb': 1,
  'Mar': 2,
  'Apr': 3,
  'May': 4,
  'Jun': 5,
  'Jul': 6,
  'Aug': 7,
  'Sep': 8,
  'Oct': 9,
  'Nov': 10,
  'Dec': 11
};


const salesLimitEntityFieldsWithDynamicAllowedValues = {
  month: { enumName: 'MonthEnum' }
};


export default class SalesLimit {
  fields = {
    month: {
      value: null
    },
    year: {
      value: null
    },
    limit: {
      value: null
    },
    new_parker_count: {
      value: null
    },
    terminating_parker_count: {
      value: null
    },
    total_parker_count: {
      value: null
    }
  };


  // @CMN Improve...
  static createFromDefaultValues(limit) {
    let values = [];

    const currentDate = new Date();
    const year = currentDate.getUTCFullYear();
    const currentUTCMonth = currentDate.getUTCMonth();

    Object.keys(monthEnum).filter(mon => monthEnum[mon] >= currentUTCMonth).map(mon => {
      values.push(SalesLimit.createFromQueryValues({ month: mon, year: year, limit: limit }));
    });

    Object.keys(monthEnum).filter(mon => monthEnum[mon] < currentUTCMonth).map(mon => {
      values.push(SalesLimit.createFromQueryValues({ month: mon, year: year + 1, limit: limit }));
    });

    return values;
  }


  static createFromQueryValues(values) {
    const salesLimit = new this();

    for (let field in salesLimit.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          default:
            salesLimit.fields[field].value = values[field];
        }
      }
    }

    return salesLimit;
  }


  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      {},
      salesLimitEntityFieldsWithDynamicAllowedValues,
      fields
    );
  }


  getQueryFieldValues() {
    const values = _.cloneDeep(SalesLimitInput);

    for (let field in values) {
      switch (field) {
        default:
          values[field] = this.fields[field].value;
      }
    }

    return values;
  }


  isSalesLimitForFutureMonth() {
    const currentDate = new Date();
    const currentUTCFullYear = currentDate.getUTCFullYear();
    const currentUTCMonth = currentDate.getUTCMonth();

    if (this.fields.year.value > currentUTCFullYear) {
      return true;
    }
    else if (this.fields.year.value === currentUTCFullYear) {
      if (monthEnum[this.fields.month.value] > currentUTCMonth) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }
}


export const SalesLimitInput = {
  month: null,
  year: null,
  limit: null
}
